<template>
    <el-row>
        <el-col :xs="24" :sm="6" v-for="(item,index) in list" :key="index">
            <div class="RecommendedProjectFrame">


                <div class="top">
                    <img class="topImg" :src="item.coverurl" alt="" />
                    <div class="topCollect">
                        <!-- 收藏 -->
                        <Collection :type="'project'" :id="item.id" :collect="item.collect" :state="false" />
                    </div>
                </div>
                <router-link :to="{path:'/DetailsLogIn',query: { id: item.id }}">
                    <div class="content">
                        <p class="contentTitle">
                            {{ item.title }}
                        </p>
                        <p class="contentSynopsis">- {{ item.smalltitle }} -</p>
                        <span class="contentSpan">
                            {{ item.introduce }}
                        </span>
                        <div class="contentTags">
                            <div class="Tag">医疗健康</div>
                            <div class="Tag">Pre-A</div>
                            <div class="Tag">{{item.city}}</div>
                        </div>
                    </div>
                    <div class="bottom">
                        <div class="bottomLeft">
                            <img src="../../../../public/static/images/play1.png" alt="">
                            路演视频
                        </div>
                        <div class="bottomRight">
                            查看BP
                        </div>
                    </div>
                </router-link>

            </div>
        </el-col>
    </el-row>


</template>

<script>
    import Collection from "@/components/Collection/Collection.vue";//收藏
    export default {
        props: {
            list: Array,
        },
        components: {
            Collection
        },
        data() {
            return {};
        },
        created: function () { },
        methods: {},
    };
</script>

<style scoped>
    .RecommendedProjectFrame {
        /* width: 270px; */
        margin: 0 auto;
        background-color: #ffffff;
        border-radius: 25px;
        margin-right: 14px;
        margin-bottom: 18px;

    }

    .top {
        position: relative;
        padding-top: 19px;
    }

    .topImg {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        margin: 0 auto;
        display: block;
    }

    .topCollect {
        position: absolute;
        top: 20px;
        right: 28px;
    }

    .topCollect span {

        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333434;
        margin-left: 5px;
    }

    .content {
        text-align: center;
    }

    .contentTitle {
        margin-top: 12px;

        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 28px;
        letter-spacing: 0px;
        color: #333333;
    }

    .contentSynopsis {
        margin-top: 11px;

        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #a1a1a1;
    }

    .contentSpan {
        margin-top: 12px;
        margin-left: 24px;
        margin-right: 37px;

        display: block;

        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 20px;
        letter-spacing: 0px;
        color: #000000;

    }

    .contentTags {
        display: flex;
        justify-content: left;
        margin-left: 24px;
        margin-top: 11px;
    }

    .Tag {

        margin-right: 5px;
        padding: 6px 11px;

        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #3696ff;
        background-color: #ebf5ff;
        border-radius: 5px;
    }

    .bottom {
        margin-top: 22px;
        display: flex;
        justify-content: space-between;
        margin-left: 24px;
        margin-right: 25px;
        padding-bottom: 24px;
    }

    .bottomLeft {
        border-radius: 17px;
        border: solid 1px #dcdcdc;

        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #494949;
        /* padding: 11px 12px 11px 47px; */
        padding: 11px 0;
        padding-left: 47px;
        padding-right: 12px;
        position: relative;
    }

    .bottomLeft img {
        position: absolute;
        top: 7px;
        left: 11px;
    }

    .bottomRight {
        border-radius: 17px;
        border: solid 1px #dcdcdc;

        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #4c4c4c;
        padding: 11px 0;
        padding-left: 11px;
        padding-right: 12px;
    }
</style>